import RateAssist from './components/RateAssist'
import RateAssistSearchResults from './components/RateAssistSearchResults'
import RateAssistRouterView from './components/RateAssistRouterView'

import store from '../../store'
import event from '../../event'
import { handleNext } from '../helpers/RouteHelpers'

export default [
  {
    path: 'rate-assist',
    component: RateAssistRouterView,
    children: [
      {
        path: '',
        component: RateAssist,
        name: 'RateAssist',
        meta: {description: 'Quickly Build Tariffs'},
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const fc = store.dispatch('systemOption/loadFinancialCodes')
          const init = store.dispatch('systemOption/initialise')
          const serviceTypes = store.dispatch('systemOption/loadServiceTypes')
          handleNext([fc, init, serviceTypes], next)
        }
      },
      {
        path: 'search',
        component: RateAssistSearchResults,
        name: 'RateAssist - Search Results',
        meta: {description: ''}
      },
      {
        path: 'clone/:id',
        component: RateAssist,
        name: 'RateAssist - Clone a Profile',
        meta: {description: ''},
        beforeEnter: (to, from, next) => {
          // @todo decrypt :id hash and http req
          event.$emit('loading-on', {})
          const fc = store.dispatch('systemOption/loadFinancialCodes')
          const init = store.dispatch('systemOption/initialise')
          const serviceTypes = store.dispatch('systemOption/loadServiceTypes')
          handleNext([fc, init, serviceTypes], next)
        }
      },
      {
        path: ':id',
        component: RateAssist,
        name: 'RateAssist - View/Update Profile',
        meta: {description: 'Quickly Build Tariffs'},
        beforeEnter: (to, from, next) => {
          // @todo decrypt :id hash and http req
          event.$emit('loading-on', {})
          const fc = store.dispatch('systemOption/loadFinancialCodes')
          const init = store.dispatch('systemOption/initialise')
          const serviceTypes = store.dispatch('systemOption/loadServiceTypes')
          handleNext([fc, init, serviceTypes], next)
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/rateassist/routes.js